import { serializeAllMethods } from "../../services/fetchMethodList";

export async function serializePromoValidate(data: any, amount: number) {
  const eligibleMethods = await serializeAllMethods(
    data.payment_methods,
    amount
  );
  return {
    walletAccepted: data.wallet_accepted,
    code: data.promocode_validate.promo_code,
    eligibleMethods,
    validBins: data.valid_bins,
    acceptsCard: data.accept_card,
  };
}
